module.exports = __webpack_public_path__ + "static/media/imgcap3.e508a9f9.jpg";